<template>
  <b-modal title="Carregar Equipamentos" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Número:" label-for="numero" label-cols-sm="3" label-align="right">
            <b-form-input id="numero" v-model="editing.numero" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Local:" label-for="local" label-cols="3" label-align="right">
            <b-form-input id="local" v-model="editing.local" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Orçamento:" label-for="orcam" label-cols="3" label-align="right">
            <b-form-input id="orcam" v-model="editing.orcamento" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Data:" label-for="data" label-cols="3" label-align="right">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Valor:" label-for="valor" label-cols="3" label-align="right">
            <b-form-input id="valor" v-model.lazy="editing.valor" v-money="money" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Serviço:" label-for="servico" label-cols="3" label-align="right">
            <b-form-input id="servico" v-model="editing.servico" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Sgcq:" label-for="sgcq" label-cols="3" label-align="right">
            <b-form-input id="sgcq" v-model.lazy="editing.sgcq" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Referência:" label-for="ref" label-cols="3" label-align="right">
            <b-form-input id="ref" v-model.lazy="editing.referencia" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="carregar()">Carregar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { VMoney } from "v-money";

export default {
  name: "ModalDeEdicaoDeFaturamento",

  data() {
    return {
      show: false,
      selecionado: null,
      editing: {
        numero: new Date().getTime() + " - " + new Date().getFullYear(),
        local: "Base da Netech - Mossoró",
        orcamento: "",
        data: new Date(),
        valor: Number(0.0),
        servico: "",
        sgcq: "",
        referencia: "",
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },

  directives: { money: VMoney },

  methods: {
    carregar() {
      this.$emit("update", this.editing);
      this.show = !this.show;
    },

    call() {
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();

    return {
      store,
    };
  },
};
</script>

<style lang="scss" scoped></style>
